import { Box, Button, Stack, styled } from "@mui/material";
import { DialogWindow } from "UI/DialogWindow";
import DashboardPreview from "images/dashboard-preview.png";
import { customColors } from "models/customColors";

export const Title = styled(Box)`
  color: ${customColors.text};
  text-align: center;
  font-family: "Inter Bold";
  font-size: 26px;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const Info = styled(Box)`
  margin-top: 15px;
  padding: 0 20px;

  min-height: 80px;

  color: ${customColors.infoText};
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const AdminDashboardGreetingsDialog = ({ open, handleClose }) => {
  return (
    <DialogWindow
      open={open}
      handleClose={handleClose}
      withCloseButton
      reducedSize
      title={
        <Stack alignItems={"center"} gap={2}>
          <img width="305" src={DashboardPreview} alt="intro slide" />
          <Title>Your Dashboard</Title>
        </Stack>
      }
      content={
        <Info maxWidth={"432px"}>
          Easily manage Senders, Referrals and Button Assignments from your
          Dashboard
        </Info>
      }
      actions={
        <Stack alignItems={"center"} flex={1} mt={1} mb={2} gap={3}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Let's Start!
          </Button>
        </Stack>
      }
    />
  );
};
